import { useState, useEffect, useCallback } from "react";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { lerConfig } from "../utils/vendaOnline";

/* Custos adicionais salvos e padrão de cada loja da venda online, em
   users/{uid}.vendaOnline (formato em utils/vendaOnline.js → lerConfig).

   Fica fora do paymentConfig de propósito: aquele é espelhado na loja
   pública, e custo interno do vendedor não é da conta de ninguém.
   onSnapshot mantém o pedido em dia se a configuração mudar em outra tela;
   paymentConfig vem junto porque a tela de padrões precisa das maquininhas. */
export function useVendaOnlineConfig(uid) {
  const [config, setConfig] = useState(() => lerConfig(null));
  const [paymentConfig, setPaymentConfig] = useState({});
  const [carregado, setCarregado] = useState(false);

  useEffect(() => {
    if (!uid) return undefined;
    return onSnapshot(
      doc(db, "users", uid),
      (snap) => {
        const dados = snap.data() || {};
        setConfig(lerConfig(dados.vendaOnline));
        setPaymentConfig(dados.paymentConfig || {});
        setCarregado(true);
      },
      () => setCarregado(true),
    );
  }, [uid]);

  const salvar = useCallback(async (novo) => {
    const limpo = lerConfig(novo);
    setConfig(limpo);
    await updateDoc(doc(db, "users", uid), { vendaOnline: limpo });
  }, [uid]);

  return { config, paymentConfig, carregado, salvar };
}
